module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/e7cbe3dc6a53bb453896a4d839d057b8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Diamond/Diamond2.svg
// module id = sR3R
// module chunks = 1